module.exports = __webpack_public_path__ + "img/logon.374b81a6.png";